module.exports = __webpack_public_path__ + "build/img/1.006c45d6.png";